const constantes = {
    dev: false,
    prod_api_uri: "https://ar-caba-sv7.seconline.net.ar:15000/",
    dev_api_uri: "http://localhost:15000/"
}

export default constantes;